module.exports = __webpack_public_path__ + "static/media/product_magazine_tile_icon.b765c453.svg";